import { render, staticRenderFns } from "./StudioSignup.vue?vue&type=template&id=5cf1e68a&scoped=true&"
import script from "./StudioSignup.vue?vue&type=script&lang=ts&"
export * from "./StudioSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1e68a",
  null
  
)

export default component.exports